<p-fluid>
    <div class="card flex flex-col gap-6 max-w-lg">
        <div class="flex items-center justify-between">
            <div class="font-semibold text-xl">Google Sign-In</div>
            @if (dirty()) {
                <p-button label="Reset all" icon="pi pi-undo" severity="secondary" outlined size="small" (click)="resetAll()" />
            }
        </div>

        <div class="flex items-center gap-3">
            <p-checkbox inputId="google-signup" [binary]="true" [ngModel]="draft().IsSignUpEnabled" (ngModelChange)="setField('IsSignUpEnabled', $event)" />
            <label for="google-signup">Sign-Up Enabled</label>
            @if (draft().IsSignUpEnabled !== realm().Google.IsSignUpEnabled) {
                <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setField('IsSignUpEnabled', realm().Google.IsSignUpEnabled)" />
            }
        </div>

        <div>
            <label class="block font-medium mb-1">Client ID</label>
            <p-inputgroup>
                <input pInputText class="w-full" [ngModel]="draft().ClientId" (ngModelChange)="setField('ClientId', $event ?? '')" />
                @if (draft().ClientId !== realm().Google.ClientId) {
                    <p-inputgroup-addon>
                        <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setField('ClientId', realm().Google.ClientId)" />
                    </p-inputgroup-addon>
                }
            </p-inputgroup>
        </div>
    </div>
</p-fluid>
